import { PrismicButton } from '@components/PrismicButton';
import { CtaButtonSliceOneCta } from '@monofront/slice-machine/prismicio-types';
import { isFilled } from '@prismicio/client';

export const CtaButtonDefault = ({ primary }: CtaButtonSliceOneCta) => {
  return (
    <div className="tw-flex tw-flex-col tw-items-center tw-gap-2">
      <PrismicButton
        field={primary.primary_cta}
        className="tw-self-stretch desktop:tw-self-auto"
      />

      {isFilled.keyText(primary.caption) && (
        <p className="tw-lf-caption-regular">{primary.caption}</p>
      )}
    </div>
  );
};
